import { NOTIFY_NOW_CONTACT_INFO, SettldContactInfo } from "@/utils/Constants";

export enum BrandName {
  SETTLD = "Settld",
  NOTIFY_NOW = "NotifyNOW",
}

export const BRAND_NAME_STORAGE_KEY = "brand_name";

export type BrandContext = {
  brand: BrandName;
  email: SettldContactInfo.Email | NOTIFY_NOW_CONTACT_INFO.Email;
  tel: SettldContactInfo.Telephone | NOTIFY_NOW_CONTACT_INFO.Telephone;
  contactUsUrl: SettldContactInfo.ContactUs | NOTIFY_NOW_CONTACT_INFO.ContactUs;
  //
  termsAndConditionsUrl:
    | SettldContactInfo.TermsAndConditionsUrl
    | NOTIFY_NOW_CONTACT_INFO.TermsAndConditionsUrl;
  privacyPolicyUrl: SettldContactInfo.PrivacyPolicyUrl | NOTIFY_NOW_CONTACT_INFO.PrivacyPolicyUrl;
  //
  reviewUrl: SettldContactInfo.ReviewUrl | NOTIFY_NOW_CONTACT_INFO.ReviewUrl;
  trustPilotUrl: SettldContactInfo.TrustPilotUrl | NOTIFY_NOW_CONTACT_INFO.TrustPilotUrl;
  contributionUrl: SettldContactInfo.ContributionUrl | NOTIFY_NOW_CONTACT_INFO.ContributionUrl;
  //
  coreWebsiteUrl: SettldContactInfo.CoreWebsiteUrl | NOTIFY_NOW_CONTACT_INFO.CoreWebsiteUrl;
  //
  intestacyRulesUrl:
    | SettldContactInfo.IntestacyRulesUrl
    | NOTIFY_NOW_CONTACT_INFO.IntestacyRulesUrl;
  cookiePolicyUrl: SettldContactInfo.CookiePolicyUrl | NOTIFY_NOW_CONTACT_INFO.CookiePolicyUrl;
  whatsApp: SettldContactInfo.WhatsApp | NOTIFY_NOW_CONTACT_INFO.WhatsApp;
};
